import React from "react";
import { WithModalConfirmation } from "../../../../../common/components/organisme/ModalWindow/ModalWindow";
import ButtonSmallIcon from "../../../../../common/components/atom/ButtonSmallIcon/ButtonSmallIcon";
import { useSingleUser } from "../../../hooks/useAdminUser";
import useNavigationApp from "../../../../../navigation/useNavigationApp";
import { useAuth } from "../../../../auth/hooks";
import { userRoles } from "../../../types/user.types";

export default function UserDeleteBtn({ userId }: { userId?: string }) {
  const {
    deleteUser,
    singleUserQuery: { isLoading, isError, data },
  } = useSingleUser(userId);
  const navigationApp = useNavigationApp();
  const { userRole } = useAuth();
  if (!userRole || userRole < userRoles.ADMIN) return <></>;
  if (isLoading || isError) return <></>;
  const handleDelete = () => {
    deleteUser.mutate({
      callback: ({ result, error }) => {
        if (!error) {
          navigationApp.goToUserList();
        }
      },
    });
  };
  return (
    <>
      <WithModalConfirmation
        modalTitle={"Confirmation"}
        confirmLabel="Supprimer"
        cancelLabel="Annuler"
        modalDescription={
          "Êtes-vous sûr de vouloir supprimer l'utilisateur " +
          data?.user_firstname +
          " " +
          data?.user_lastname +
          " ?"
        }
        onComfirm={handleDelete}
        buttonRender={({ openModal }) => (
          <ButtonSmallIcon
            iconType={"trash"}
            label="Supprimer"
            variant="stack"
            onClick={openModal}
          />
        )}
      />
    </>
  );
}
